import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { PageComponent } from '../../layout/page/page.component';
import { TranslationService } from '../../../core/services/translation/translation.service';
import { formLanguageReloader } from '../../../core/helpers/page.helper';
import { LogService } from '../../../core/services/log/log.service';
import { UserService } from '../../user-connection/user.service';
import { ApplicationStore } from '../../../core/services/application-store.service';
import { NoValue } from '@tribeauto/ngx-mobilite-material';
import { AppConfig } from '../../../app.config';

@Component({
  selector: 'pvmo-administration',
  imports: [PageComponent],
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrationComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translationService = inject(TranslationService);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly logService = inject(LogService);
  private readonly userService = inject(UserService);
  private readonly appConfig = inject(AppConfig);
  private readonly LANDING = 'mobi-admin-landing';
  private readonly PAGE_NAME = 'page-administration';
  isUserConnected = this.userService.isUserConnected;

  constructor() {
    effect(() => {
      const selected = this.translationService.selectedFile();
      formLanguageReloader(this.LANDING, this.PAGE_NAME, selected);
      this.cdr.markForCheck();
    });

    effect(() => {
      const userData = this.applicationStore.instant('userData')();
      let userSub: string | NoValue = undefined;
      if (this.appConfig.devOrLocal) {
        userSub = userData?.login;
      }
      this.createDetailComponent(userSub);
    });
  }

  private createDetailComponent(userSub: string | NoValue): void {
    const detailComponent = document.createElement(this.LANDING);
    detailComponent.setAttribute('nonce', 'NGINX_CSP_NONCE');
    detailComponent.setAttribute('language', this.translationService.selectedFile());
    detailComponent.setAttribute('session-uuid', this.logService.sessionUuid());
    if (userSub) {
      detailComponent.setAttribute('user-sub', userSub);
    }
    const page = document.getElementById(this.PAGE_NAME);
    if (page) {
      page.append(detailComponent);
      this.cdr.markForCheck();
    }
  }
}
